<ng-container *transloco="let t; read: 'tenant'">
  <h2>{{ t('title') }}</h2>

  <kendo-grid [data]="tenants" [resizable]="true" (add)="addHandler($event)" (save)="saveHandler($event)"
    (cancel)="cancelHandler($event)" [style.maxHeight.px]="600">

    <ng-template kendoGridToolbarTemplate>
      <button kendoGridAddCommand>{{ t('addNew') }}</button>
    </ng-template>

    <kendo-grid-column field="name" [title]="t('name')" width="180"> </kendo-grid-column>

    <kendo-grid-column field="adminEmail" [title]="t('adminEmail')" width="180"> </kendo-grid-column>

    <kendo-grid-column field="id" title="ID" width="75"> </kendo-grid-column>

    <kendo-grid-column field="validUpto" [title]="t('validUpto')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.validUpto | date: "dd.MM.yyyy" }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="isActive" [title]="t('status')" width="75">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isActive ? t('active') : t('inactive') }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="userLicenses" [title]="t('licenses')" width="75"> </kendo-grid-column>
    <kendo-grid-column field="activeUsers" [title]="t('userCount')" width="75" > </kendo-grid-column>
    <kendo-grid-column field="modules" [title]="t('modules')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ getActiveModules(dataItem) }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column [title]="t('action')" width="180">

      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="dataItem.id && !isAddingNew">
          <button kendoButton fillMode="outline" size="small" rounded="small" themeColor="success" class="mbs"
            (click)="onEdit(dataItem)">
            {{ t('edit') }}
          </button>
          <button kendoButton fillMode="outline" size="small" rounded="small" themeColor="success" class="mbs"
            (click)="onUpgrade(dataItem)">
            {{ t('validity') }}
          </button>
          <button kendoButton fillMode="outline" size="small" rounded="small" class="mbs"
            [themeColor]="dataItem.isActive ? 'error' : 'warning'" (click)="onChangeState(dataItem)">
            {{ dataItem.isActive ? t('deactivate') : t('activate') }}
          </button>
        </ng-container>


        <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
          {{ t('add') }}
        </button>
        <button kendoGridCancelCommand>
          {{ t('cancel') }}
        </button>
      </ng-template>
    </kendo-grid-command-column>

  </kendo-grid>

  <!-- Update Subscription Form -->
  <kendo-dialog *ngIf="isDialogActive" (close)="closeDialog()">

    <kendo-dialog-titlebar>
      {{ t('subscriptionTitle') }}
    </kendo-dialog-titlebar>

    <form novalidate class="k-form" [formGroup]="updateSubscriptionForm">
      <kendo-formfield>
        <kendo-label [for]="extendedExpiryDate" [text]="t('validityUntil')"></kendo-label>
        <kendo-datepicker formControlName="extendedExpiryDate" #extendedExpiryDate required>
        </kendo-datepicker>
      </kendo-formfield>
    </form>
    <kendo-dialog-actions>
      <button kendoButton (click)="onCancel($event)">{{ t('cancel') }}</button>
      <button kendoButton themeColor="primary" [disabled]="!updateSubscriptionForm.valid" (click)="onSave($event)">
        {{ t('save') }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>

    <!-- Update Tenant Form -->
    <kendo-dialog *ngIf="isDialogEditActive" (close)="closeEditDialog()">
      <kendo-dialog-titlebar>
        {{ t('editTenantTitle') }}
      </kendo-dialog-titlebar>
      <form novalidate class="k-form" [formGroup]="updateTenantForm">
        <kendo-formfield>
          <kendo-label for="userLicenses" [text]="t('userLicenses')"></kendo-label>
          <kendo-numerictextbox formControlName="userLicenses" format="0"></kendo-numerictextbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label for="timeModule" [text]="t('timeModule')"></kendo-label>
          <kendo-checkbox formControlName="timeModule"></kendo-checkbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label for="schedulerModule" [text]="t('schedulerModule')"></kendo-label>
          <kendo-checkbox formControlName="schedulerModule"></kendo-checkbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label for="assignmentModule" [text]="t('assignmentModule')"></kendo-label>
          <kendo-checkbox formControlName="assignmentModule"></kendo-checkbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label for="fileModule" [text]="t('fileModule')"></kendo-label>
          <kendo-checkbox formControlName="fileModule"></kendo-checkbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label for="expenseModule" [text]="t('expenseModule')"></kendo-label>
          <kendo-checkbox formControlName="expenseModule"></kendo-checkbox>
        </kendo-formfield>

      </form>
      <kendo-dialog-actions>
        <button kendoButton (click)="onCancelEdit($event)">{{ t('cancel') }}</button>
        <button kendoButton themeColor="primary" [disabled]="!updateTenantForm.valid" (click)="onSaveEdit($event)">
          {{ t('save') }}
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
</ng-container>
